import { render, staticRenderFns } from "./dev_cap.vue?vue&type=template&id=4f67c85e&scoped=true&"
import script from "./dev_cap.vue?vue&type=script&lang=js&"
export * from "./dev_cap.vue?vue&type=script&lang=js&"
import style0 from "./dev_cap.vue?vue&type=style&index=0&id=4f67c85e&scoped=true&lang=less&"
import style1 from "./dev_cap.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f67c85e",
  null
  
)

export default component.exports